const NotReadBadge = ({ invisible }: { invisible?: boolean }) => {
  if (invisible) {
    return null;
  }
  return (
    <div
      aria-label="not-read-badge"
      className="mx-1 flex size-2 shrink-0 flex-col self-center rounded-full bg-info-main"
    />
  );
};

export default NotReadBadge;
